// @ts-nocheck
import styled from 'styled-components';

export const ReportingSectionTogglesStyle = styled.div`
  width: 100%;
  background-color: rgba(245,249,249,0.8);
  display: flex;
  .reportingSectionToggles {
    &__container {
      display: flex;
      align-items: center;
      height: 56px;
    }
    &__sectionsSelector {

    }
    &__saveButton {
      margin-left: auto;
      padding: 8px;
      .buttonWrapper__iconWrapper {
        padding-right: 0 !important;
      }
    }
  }
`;
